/**************************************************
 * Nombre:       Tarjeta_Noticias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BotonTransparente from "../Tarjetas_Especiales/Componentes/BotonTransparente";
import {WebOutlined} from "@mui/icons-material";
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Noticias = ({item}) => {

    const click = () => {
        irUrl(item.link)
    }

    return (
        <Grid
            container
            direction="row-reverse"
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={4}
        >

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 18, fontWeight: 600}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography sx={{fontSize: 14, fontWeight: 400}}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <BotonTransparente Icono={WebOutlined} titulo={'Ver Completa'} click={click}/>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Noticias    